import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    selection: _ctx.state.selectedRow,
    "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.selectedRow) = $event)),
    filters: _ctx.filters,
    "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters) = $event)),
    class: "p-datatable-sm",
    "column-resize-mode": "fit",
    "resizable-columns": true,
    "responsive-layout": "scroll",
    lazy: true,
    page: _ctx.state.lazyParams.page,
    rows: _ctx.state.lazyParams.rows,
    "total-records": _ctx.state.lazyParams.total,
    "selection-mode": "single",
    value: _ctx.state.infrastructureGroup,
    "filter-display": "menu",
    paginator: true,
    "rows-per-page-options": [5, 10, 40],
    "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
    "current-page-report-template": `{currentPage} ${_ctx.t(
      'content.globalPagingInformation.ofTitle'
    )} {totalPages} ${_ctx.t('content.globalPagingInformation.pagesTitle')}`,
    "data-key": "id",
    loading: _ctx.state.dataLoading,
    onRowSelect: _ctx.onRowSelect,
    onPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPaginatorResearchEquipmentClick($event)))
  }, {
    paginatorend: _withCtx(() => []),
    empty: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.t("content.noData")), 1)
    ]),
    loading: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.t("content.globalLoadingText")), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        "selection-mode": "single",
        style: {"width":"40px"},
        exportable: false
      }),
      _createVNode(_component_Column, {
        field: "name",
        header: 
        _ctx.t('content.dataManagement.content.infrastructure.table.header.name')
      ,
        style: {"width":"30%"}
      }, {
        editor: _withCtx(({ data, field }) => [
          _createVNode(_component_InputText, {
            modelValue: data[field],
            "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
            autofocus: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "description",
        header: 
        _ctx.t(
          'content.dataManagement.content.infrastructure.table.header.description'
        )
      ,
        style: {"width":"30%"}
      }, {
        editor: _withCtx(({ data, field }) => [
          _createVNode(_component_InputText, {
            modelValue: data[field],
            "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
            autofocus: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "researchOrganization",
        header: 
        _ctx.t(
          'content.dataManagement.content.infrastructure.table.header.organization'
        )
      ,
        style: {"width":"30%"}
      }, {
        body: _withCtx((slotProps) => [
          _createTextVNode(_toDisplayString(slotProps.data.researchOrganizationName), 1)
        ]),
        _: 1
      }, 8, ["header"])
    ]),
    _: 1
  }, 8, ["selection", "filters", "page", "rows", "total-records", "value", "current-page-report-template", "loading", "onRowSelect"]))
}